import React from 'react';
import { Users, Network, Wifi, HardDrive } from 'lucide-react';

/**
 * Empat stat cards: Total Aktif, PPPoE, Hotspot, DHCP.
 * Hilang otomatis kalau router belum dipilih atau data session belum ada.
 */
export const MPanelStatsCards = ({ visible, activeSessions, dhcpLeases }) => {
  if (!visible || !activeSessions) return null;
  const pppoeCount = activeSessions.pppoe_sessions?.length || 0;
  const hotspotCount = activeSessions.hotspot_sessions?.length || 0;
  const dhcpCount = dhcpLeases?.length || 0;
  const total = pppoeCount + hotspotCount + dhcpCount;

  const Card = ({ label, value, sub, color, Icon }) => (
    <div className={`bg-gradient-to-br ${color} rounded-lg shadow-sm p-3 text-white`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-xs font-medium opacity-80 mb-0.5">{label}</p>
          <p className="text-2xl font-bold">{value}</p>
          <p className="text-xs opacity-80 mt-0.5">{sub}</p>
        </div>
        <div className="bg-white/20 p-2 rounded-lg">
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </div>
  );

  return (
    <div data-testid="mpanel-stats-cards" className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Card label="Total Aktif" value={total} sub="Koneksi" color="from-blue-500 to-blue-600" Icon={Users} />
      <Card label="PPPoE" value={pppoeCount} sub="Sesi Aktif" color="from-green-500 to-green-600" Icon={Network} />
      <Card label="Hotspot" value={hotspotCount} sub="Sesi Aktif" color="from-orange-500 to-orange-600" Icon={Wifi} />
      <Card label="DHCP" value={dhcpCount} sub="Lease Aktif" color="from-purple-500 to-purple-600" Icon={HardDrive} />
    </div>
  );
};
